import {AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {HttpRejectReasonsService} from '@infrastructure/http/reject-reason/http-reject-reasons.service';
import {AssertionUtils, CheckName} from '@vdw/angular-component-library';
import {Observable, Observer, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, switchMap, take} from 'rxjs/operators';

export class RejectReasonCodeValidator {
  public static createRejectReasonCodeValidator(rejectReasons: HttpRejectReasonsService, machineTypeIds: number[], existingValue: number): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return new Observable((observer: Observer<number>) => observer.next(control.value)).pipe(
        debounceTime(500),
        distinctUntilChanged(),
        take(1),
        switchMap((value: number) => {
          let result;

          if (AssertionUtils.isNullOrUndefined(value) || (!AssertionUtils.isNullOrUndefined(existingValue) && value === existingValue)) {
            result = of(null);
          } else {
            result = rejectReasons.isCodeAvailable(value, machineTypeIds).pipe(map((checkName: CheckName) => (checkName.isAvailable ? null : {identifierTaken: true, entityId: checkName.id})));
          }

          return result;
        })
      );
    };
  }
}
